import { Component } from '@theme/component';

/** @extends {Component<{chatButtons?: HTMLButtonElement[]}>} */
class OhCustomChannels extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.syncChat();
    customElements.whenDefined('shopify-chat').then(() => {
      if (this.isConnected) this.syncChat();
    });
  }

  updatedCallback() {
    super.updatedCallback();
    this.syncChat();
  }

  actualChat() {
    return customElements.get('shopify-chat') ? document.querySelector('shopify-chat') : null;
  }

  syncChat() {
    const available = Boolean(this.actualChat());
    for (const button of this.refs.chatButtons || []) button.hidden = !available;
  }

  openChat() {
    const chat = this.actualChat();
    if (!chat) {
      this.syncChat();
      return;
    }
    chat.setAttribute('mode', 'standalone');
    chat.setAttribute('open', '');
  }
}

if (!customElements.get('oh-custom-channels-component')) {
  customElements.define('oh-custom-channels-component', OhCustomChannels);
}
